export const isRunningInFEDSite = (): boolean => {
    const serverHost = window?.location?.host;

    if (!serverHost) {
        return false;
    }

    return serverHost.startsWith('localhost:300') || serverHost.endsWith('.luminary.space') || serverHost.endsWith('.netlify.app');
};
